export function dataTabel() {
  // Check if any table exists
  if (jQuery('.table').length > 0) {
		var lang_da_mod = {
			sProcessing: "Henter...",
			sLengthMenu: "Vis _MENU_ linjer",
			sZeroRecords: "Ingen linjer matcher søgningen",
			sInfo: "Viser _START_ til _END_ af _TOTAL_ linjer",
			sInfoEmpty: "Viser 0 til 0 af 0 linjer",
			sInfoFiltered: "(filtreret fra _MAX_ linjer)",
			sSearch: "Søg:",
			sUrl: "",
			oPaginate: {
				sFirst: "Første",
				sPrevious: "Forrige",
				sNext: "Næste",
				sLast: "Sidste"
			},
      aria: {
        orderable: "",
        orderableReverse: "",
        sortAscending: " :aktiver for at sortere kolonnen stigende",
        sortDescending: " :aktiver for at sortere kolonnen faldende",
        // orderable: ": aktiver for at sortere kolonnen stigende",
        // orderableReverse: ": aktiver for at sortere kolonnen faldende"
      }
		};

		// Iterate through each table
		jQuery('.table').each(function () {
			var table = jQuery(this);
			var id = table.attr("id"); // Ensure the table has an ID
			if (!id) {
				console.warn('Table is missing an ID and will not be initialized.');
				return; // Skip this table if no ID is found
			}

			var search = table.data('search');
			var searchfield = table.data('searchfield');
			// Configuration for tables with 'table--collapse' class
			if (table.hasClass('table--collapse')) {
				var entries = table.data('entries');
				var all = table.data('all');
				var lenghMenu = table.data('lengthmenu');
				var pagination = table.data('pagination');
				var info = table.data('info');
				var caption = table.data('caption');
				if (caption && table.find('caption').length === 0) {
					table.prepend('<caption>' + caption + '</caption>');
				}

				lang_da_mod.sLengthMenu = '<select>' +
					'<option value="-1">' + all + '</option>' +
					'<option value="10" selected>10</option>' +
					'<option value="20">20</option>' +
					'<option value="30">30</option>' +
					'</select>';
				lang_da_mod.searchPlaceholder = search;
				lang_da_mod.sSearch = "";
        lang_da_mod.oPaginate.sFirst = "";
				lang_da_mod.oPaginate.sNext = "";
				lang_da_mod.oPaginate.sPrevious = "";
				lang_da_mod.oPaginate.sLast = "";
				lang_da_mod.searchfield = searchfield;
				// Set pagination based on the table data attribute
				lang_da_mod.sPaginationType = pagination ? "full_numbers" : "simple";

				// Initialize the collapsed table
				addTable(id, lang_da_mod, pagination); // Pass pagination flag to the addTable function
			} else {
				// Configuration for other tables
				entries = table.data('entries');
				lenghMenu = table.data('lengthmenu');
				pagination = table.data('pagination');
				info = table.data('info');

				lang_da_mod.sLengthMenu = lenghMenu;
				lang_da_mod.pagination = pagination;
				lang_da_mod.searchfield = searchfield;
				lang_da_mod.searchPlaceholder = search;
				lang_da_mod.sSearch = "";
				lang_da_mod.info = entries;
        lang_da_mod.oPaginate.sFirst = "";
				lang_da_mod.oPaginate.sNext = "";
				lang_da_mod.oPaginate.sPrevious = "";
				lang_da_mod.oPaginate.sLast = "";

				// Initialize the scrollable table
				addTableScrollable(id, lang_da_mod); // Call the addTableScrollable function for non-collapsed tables
			}
		});
  }
}

function setupControlCellAria(id) {
  // Hide the unlabeled expand/collapse column header — it carries no useful text
  jQuery('#' + id + ' thead th:first-child').attr('aria-hidden', 'true');

  // Action prefix for aria-label — configurable via data-expand-label on the table element
  var expandLabel = jQuery('#' + id).data('expand-label') || 'Vis detaljer for';

  jQuery('#' + id + ' tbody tr:not(.child)').each(function() {
    var $row = jQuery(this);
    var $control = $row.find('td.control');
    if (!$control.length) return;

    var labelText = $row.find('td:not(.control)').first().text().trim().replace(/\s+/g, ' ');
    if (labelText.length > 80) labelText = labelText.substring(0, 80) + '…';

    $control.attr({
      'role': 'button',
      'tabindex': '0',
      'aria-expanded': $row.hasClass('parent') ? 'true' : 'false',
      'aria-label': labelText ? (expandLabel + ' ' + labelText) : 'Vis detaljer'
    });
  });
}

// Initialize DataTable for regular tables
function addTable(id, lang_da_mod, pagination) {
  jQuery('#' + id).DataTable({
    ordering: true,
    retrieve: true,
    "info": Boolean(lang_da_mod.info), // Explicitly cast to boolean
    searching: lang_da_mod.searchfield,
    "bLengthChange": lang_da_mod.lenghMenu,
    "bPaginate": pagination, // Use the pagination flag passed from the data attributes
    "sPaginationType": lang_da_mod.sPaginationType || "simple", // Use custom pagination type
    responsive: {
      details: {
        type: 'column'
      }
    },
    columnDefs: [{
      className: 'control',
      orderable: false,
      targets: 0
    }],
    "language": lang_da_mod,
    initComplete: function() {
      setupControlCellAria(id);
      jQuery('.dataTables_paginate .first')
        .attr('aria-label', 'Første')
        .attr('title', 'Første');
      jQuery('.dataTables_paginate .previous')
        .attr('aria-label', 'Forrige')
        .attr('title', 'Forrige');
      jQuery('.dataTables_paginate .next')
        .attr('aria-label', 'Næste')
        .attr('title', 'Næste');
      jQuery('.dataTables_paginate .last')
        .attr('aria-label', 'Sidste')
        .attr('title', 'Sidste');
    },
    drawCallback: function(settings) {
      setupControlCellAria(id);
      jQuery('.dataTables_paginate .first')
        .attr('aria-label', 'Første')
        .attr('title', 'Første');
      jQuery('.dataTables_paginate .previous')
        .attr('aria-label', 'Forrige')
        .attr('title', 'Forrige');
      jQuery('.dataTables_paginate .next')
        .attr('aria-label', 'Næste')
        .attr('title', 'Næste');
      jQuery('.dataTables_paginate .last')
        .attr('aria-label', 'Sidste')
        .attr('title', 'Sidste');
    }
  });

  jQuery('#' + id).on('responsive-display.dt', function(e, datatable, row, showHide) {
    jQuery(row.node()).find('td.control').attr('aria-expanded', showHide ? 'true' : 'false');
  });

  jQuery('#' + id).on('keydown', 'td.control', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.click(); // Native DOM click — reaches DataTables' own event listeners
    }
  });

  removeTabIndexFromHiddenTables();

  setTimeout(function () {
    jQuery('.table').css('opacity', 1);
    jQuery('.dataTables_wrapper').css('opacity', 1);
    jQuery('.dataTables_wrapper input').prop('required', true);
    jQuery('.dataTables_wrapper input').parent('label').attr('aria-label', 'Søg i tabel');
  }, 100);
}

// Initialize DataTable for scrollable tables (with fixed columns)
function addTableScrollable(id, lang_da_mod) {
  let resizeTimeout;
  jQuery(window).on("load resize", function () { // Mobile responsiveness
		var table = jQuery('#' + id); // Ensure we're using the correct table ID

		if (table.length === 0) {
			console.error('Table with id ' + id + ' not found.');
			return; // Skip if table doesn't exist
		}
    // Ensure the table is wrapped inside a div with class 'table--scrollable-container'
    if (!table.parent().hasClass('table--scrollable-container')) {
      table.wrap('<div class="table--scrollable-container"></div>');
    }
  });

  jQuery('#' + id).DataTable({
		ordering: true,
		retrieve: true,
		"info": lang_da_mod.info,
		searching: lang_da_mod.searchfield,
		"bLengthChange": lang_da_mod.lenghMenu,
		"bPaginate": lang_da_mod.pagination,
		columnDefs: [{
			className: 'control',
			orderable: false,
			targets: 0
		}],
		fixedColumns: true,
		"language": lang_da_mod,
/* 		scrollX: true, */
		scrollCollapse: true,
		initComplete: function () {
			// Add ARIA attributes for accessibility
			const tableId = '#' + id;
			const headTable = jQuery(tableId).closest('.dataTables_scroll').find('.dataTables_scrollHead table');
			const bodyTable = jQuery(tableId).closest('.dataTables_scroll').find('.dataTables_scrollBody table');

			// Associate header table with body table
			headTable.attr('aria-hidden', true); // Indicate that it's not a separate table

			// Remove roles from `thead`, `tbody`, and `tfoot` (if added by DataTables)
			headTable.find('thead, tbody, tfoot').removeAttr('role');
			bodyTable.find('thead, tbody, tfoot').removeAttr('role');

			headTable.removeAttr('role');
			bodyTable.removeAttr('role');

			// Remove roles from rows (`role="row"`) and cells (`role="cell"`)
			bodyTable.find('tr, td, th').removeAttr('role');
			headTable.find('tr, td, th').removeAttr('role');

      // Adjust tabindex for non-interactive elements inside scrollable body
      bodyTable.find('td').each(function () {
        // If there's no interactive element (link, button, input), set tabindex="-1"
        jQuery(this).removeAttr('tabindex');
      });
		}
  });
  removeTabIndexFromHiddenTables();

  setTimeout(function () {
		jQuery('.table').css('opacity', 1);
		jQuery('.dataTables_wrapper').css('opacity', 1);
		jQuery('.dataTables_wrapper input').prop('required', true);
		jQuery('.dataTables_wrapper input').parent('label').attr('aria-label', 'Søg i tabel');

  }, 100);
}

function removeTabIndexFromHiddenTables() {
  jQuery('table[aria-hidden="true"]').each(function () {
    jQuery(this).find('[tabindex]').removeAttr('tabindex');
  });
}

export default dataTabel;
